import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { Usuario } from './models/usuario';
import { Perfil } from './models/perfil';
import { Fornecedor } from '../fornecedor/models/fornecedor';
import { filtroDashboard } from '../dashboard/models/dashboard';

@Injectable({
    providedIn: 'root'
  })

export class UsuarioService{
    
  private environmentUrl: string = '';    

  constructor(private httpClient: HttpClient) {
      this.environmentUrl = environment.ApiCore;
    }

  getUsuarios() : Observable<Usuario[]>{
    let url = this.environmentUrl+"/Usuario";        
    return this.httpClient.get<Usuario[]>(url);
  }

  addUsuarios(newUser: Usuario){     
    return this.httpClient.post(this.environmentUrl+"/Usuario", newUser);
  }

  updUsuarios(user: Usuario){     
    return this.httpClient.put(this.environmentUrl+"/Usuario", user);
  }   

  delUsuarios(user: Usuario){     
    return this.httpClient.delete(this.environmentUrl+"/Usuario/"+user.idUsuario);
  }  
  
  getPerfil() : Observable<Perfil[]>{
    let url = this.environmentUrl+"/Perfil";        
    return this.httpClient.get<Perfil[]>(url);
  }

  getSelectedPerfil(id: number) : Observable<Perfil[]>{
    let url = this.environmentUrl+"/Usuario/UsuarioPerfil/"+id;        
    return this.httpClient.get<Perfil[]>(url);
  }

  resetSenha(user: Usuario){     
    user.senha = user.login;
    return this.httpClient.put(this.environmentUrl+"/Usuario", user);
  }   

  getFornecedorChecked(idUsuario: number) : Observable<Fornecedor[]>{
    let url = this.environmentUrl+"/Usuario/Fornecedor/"+idUsuario;        
    return this.httpClient.get<Fornecedor[]>(url);
  }


  getFornecedoresChecked() : Observable<Fornecedor[]>{
    let url = this.environmentUrl+"/Usuario/Fornecedor";        
    return this.httpClient.get<Fornecedor[]>(url);
  }

  updUsuarioFornecedor(selectedFornecedores: Fornecedor[], idUsuario: number) {    
    return this.httpClient.post(this.environmentUrl + "/Usuario/Fornecedor/"+idUsuario, selectedFornecedores);
  }

  updUsuarioPerfil(selectedPerfil: Perfil[], idUsuario: number) {    
    return this.httpClient.post(this.environmentUrl + "/Usuario/Perfil/"+idUsuario, selectedPerfil);
  }

  getVendedoresDashboard(idEvento: string) {
    return this.httpClient.get<filtroDashboard[]>(this.environmentUrl + "/Usuario/FiltroDashboard/" + idEvento);
}
}

  
  